/**
 * The states Zlayt AI accepts cases in (ZLAYT-1486).
 *
 * Each state carries its own evidence rule written into letters, and only
 * these have had a legal review. Jack's decision (4 Nov 2026): keep these,
 * say so at sign-up and on the plans, and add states one at a time after a
 * legal review of each. The backend holds the same list
 * (zlayt_ai_backend common/incident_states.py) and refuses any other state
 * with STATE_FIELD_HELP's words; change both together.
 */
export const SUPPORTED_STATES: readonly string[] = [
  'Arizona',
  'Colorado',
  'New Mexico',
  'Texas',
];

const spokenList = (names: readonly string[]): string =>
  names.length < 2
    ? names.join('')
    : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;

/** Shown where people sign up and where plans and prices are shown. */
export const SUPPORTED_STATES_NOTICE = `Zlayt AI currently supports cases in ${spokenList(
  SUPPORTED_STATES
)}. We add states one at a time after a legal review of each.`;

/** Shown under the State field of a case. */
export const STATE_FIELD_HELP = `Zlayt AI supports cases in ${spokenList(
  SUPPORTED_STATES
)} for now. We add states one at a time after a legal review.`;
